<!-- Button — styled as a user-menu row so it matches its siblings in the
     user menu (same height, icon size, and hover treatment). -->
<button class="user-menu-item w-full" (click)="toggleFullscreen()">
  <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
  <span>{{ 'FULLSCREEN' | translate }}</span>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
  <primecontrol-svg-icon
    class="icon-size-4 shrink-0 text-[color:var(--text-subtitle)]"
    [svgIcon]="'heroicons_outline:arrows-expand'"
  ></primecontrol-svg-icon>
</ng-template>
